import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle, ArrowRight } from 'lucide-react';
import { AffiliateHeader, AffiliateFooter } from '../../components/affiliate/AffiliateChrome';
import { affiliateApi, setAuthToken, buildAffiliatePath } from '../../lib/affiliate';

const AffiliateLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const data = await affiliateApi('/affiliates/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      if (data.token) setAuthToken(data.token);
      navigate(buildAffiliatePath('/dashboard'));
    } catch (e2) {
      setErr(e2.message || 'Login failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white">
      <AffiliateHeader />
      <section className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-display text-3xl font-bold mb-2">Affiliate sign in</h1>
        <p className="text-neutral-400 mb-7">Welcome back. Sign in to manage your affiliate dashboard.</p>
        {err && (
          <div className="mb-5 p-4 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-sm flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 mt-0.5" />
            <span>{err}</span>
          </div>
        )}
        <form onSubmit={onSubmit} className="bg-neutral-900/60 border border-neutral-800 rounded-2xl p-6 space-y-5" data-testid="affiliate-login-form">
          <label className="block">
            <span className="block text-xs font-semibold uppercase tracking-wider text-neutral-400 mb-1.5">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-neutral-900 px-4 py-3 rounded-xl border border-neutral-700 focus:border-axon-500 outline-none" data-testid="login-email" />
          </label>
          <label className="block">
            <span className="block text-xs font-semibold uppercase tracking-wider text-neutral-400 mb-1.5">Password</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-neutral-900 px-4 py-3 rounded-xl border border-neutral-700 focus:border-axon-500 outline-none" data-testid="login-password" />
          </label>
          <button type="submit" disabled={busy} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-gradient-to-r from-axon-600 to-axon-500 hover:from-axon-500 hover:to-axon-400 disabled:opacity-60 text-white font-bold uppercase tracking-wider text-sm shadow-button hover:shadow-glow-cyan transition-all" data-testid="login-submit">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
          </button>
          <p className="text-center text-xs text-neutral-500">
            New here? <Link to={buildAffiliatePath('/apply')} className="text-axon-400 hover:text-axon-300">Apply for an account</Link>
          </p>
        </form>
      </section>
      <AffiliateFooter />
    </div>
  );
};

export default AffiliateLoginPage;
